<template>
  <HeroImage id="pagrindinis"></HeroImage>
  <Statistics type="digging"></Statistics>
  <Services></Services>
  <CTASection title="Paruošti pradėti?" text="Susisiekite su mumis dar šiandien ir gaukite nemokamą konsultaciją"></CTASection>
  <Vizija id="apie_mus"></Vizija>
  <Testimonials type="digging"></Testimonials>
  <ProcessSteps></ProcessSteps>
  <Gallery id="galerija"></Gallery>
  <FAQ type="digging"></FAQ>
  <Map></Map>
  <Contact id="kontaktai"></Contact>
  <SolarGallery></SolarGallery>
  <Footer type="digging"></Footer>
  <FloatingPhoneButton></FloatingPhoneButton>
  <ScrollToTop></ScrollToTop>
</template>

<script>
import ScrollToTop from "@/components/ScrollToTop";
import Footer from "@/views/auto/Footer";
import Contact from "@/views/auto/Contact";
import HeroImage from "@/views/digging/HeroImage";
import Services from "@/views/digging/Services";
import Vizija from "@/views/digging/Vizija";
import ProcessSteps from "@/views/digging/ProcessSteps";
import Gallery from "@/views/digging/Gallery";
import Map from "@/views/Map";
import SolarGallery from "@/components/SolarGallery";
import Statistics from "@/components/Statistics";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import FloatingPhoneButton from "@/components/FloatingPhoneButton";
import CTASection from "@/components/CTASection";
export default {
  name: "KasimoDarbai",
  components: {
    Map,
    Gallery,
    Vizija,
    ProcessSteps,
    Services,
    HeroImage,
    Footer,
    Contact,
    ScrollToTop,
    SolarGallery,
    Statistics,
    Testimonials,
    FAQ,
    FloatingPhoneButton,
    CTASection,
  },

  setup(){

    return {

    };
  }
}
</script>

<style scoped>

</style>